import React from 'react';
import PropTypes from 'prop-types';
import CSSTransition from '../CSSTransition';
import './style.scss';

const CircularLoaderInline = ({containerStyle, className, style}) => (
    <CSSTransition animation="fade-quick" className="flexbox-fill flex-center" style={containerStyle}>
        <div className={`circular-loader ${className}`} style={style}/>
    </CSSTransition>
);

CircularLoaderInline.propTypes = {
    style: PropTypes.object,
    containerStyle: PropTypes.object
};
export default CircularLoaderInline;
